// Module
var code = "<div class=\"tw-my-2 tw-mx-0 tw-border-b tw-border-primary-l7\"></div>";
// Exports
module.exports = code;